import Snackbar from './Snackbar';
import { setConnectionErrorCallback } from '../EventoServer/connectionError';
import SnackbarWrapper from './SnackbarWrapper';

//  Export secondario
export { default as SnackbarWrapper } from './SnackbarWrapper';

// Di default, se viene importata la Snackbar questa diventa l'handler dei problemi di connessione.
// Introdotto per evitare un dipendenza tra WebRequest e Snackbar che costa circa 9k nel bundle.
setConnectionErrorCallback((errorMessage) => {
  SnackbarWrapper.notifyError(errorMessage, false, 25000);
});

export default Snackbar;
